//type PaymentMethod = 'card' | 'applepay' | 'samsungpay' | 'benefitpay' | 'knet' | 'mada';
type PaymentMethod = 'card';
//| "stcpay"; // expand as needed

export interface IChargeData {
  tokenId: any,
  totalAmount: number,
  currency: string,
  customer: ICustomer,
  //method: string
  method: PaymentMethod,
  //new 
  description: string | undefined,
  saveCard: boolean,
  flow: "SUBSCRIPTION" | "UNSCHEDULED" | "INVOICE";
  planId: number,
  vatAmount: number,
  vatRate: number,
  amount: number,
  paymentTypeId: number,
  purposeId: number,
  sourceId: number,
  isUpgrade: boolean,
  isActivation: boolean,
  planName?: string
}

export interface ICustomer {
  firstName: string;
  lastName: string;
  email: string;
  phone: IPhone;
}

export interface IPhone {
  countryCode: string;
  number: string;
}

export type ChargeResponse = {
  status: string;
  id?: string;
  transaction?: { url?: string };
  response?: {
    code?: string;
    message?: string;
  };
  // other fields returned by Tap...
};

export interface IPlanSummary {
  planId: number;
  planTypeId: number;
  planName: string;
  description?: string;
  tag?: string;
  rank: number;
  planDurationId: number;
  priceSAR: number;
  vatRate: number;
  vatAmountSAR: number;
  totalAmountSAR: number;
  priceUSD: number;
  expirationDate: string;
  renewalDate?: string;
  statusId: number;
  isCanceled: boolean;
  isPublished: boolean;
  isRetired: boolean;
  nextPlanId?: number;
  planItems: IPlanItem[];
}

export interface IPlanItem {
  id: number,
  order: number,
  description: string
}

export interface ISubscriptionPlans {
  key: string;
  title: string;
  description: string;
  price: number;
  features: string[];
  tag?: string;
  rank: number;
  isBillable: boolean;
}

export interface ISubscriptionPlan {
  id: number;
  planTypeId: number;
  name: string;
  description?: string;
  tag?: string;
  rank: number;
  planDurationId: number;
  planDurationName: string;
  planDays: number;
  priceSAR: number;
  priceUSD: number;
  vatRate: number;
  vatAmountSAR: number;
  totalAmountSAR: number;
  planItems: IPlanItem[];
  isNextPlan?: boolean;
}

export interface IPlanItem {
  PlanId: number;
  displayOrder: number;
  description: string;
}

export interface IPlanFeatures {
  planId: number;
  featureId: number;
  featureName: string;
  featureTypeId: number;
  featureTypeName: string;
  value: string;
}

export interface IContactSalesFormData {
  id?: number;
  fullName: string;
  email: string;
  companyName: string;
  phoneNumber?: string;
  tellUs: string;
}

export enum PLAN_DURATION {
  MONTHLY = 1,
  ANNUAL = 2,
  CUSTOM = 3,
}

export interface IPackageConsumption {
  channelName: string;
  volume: number;
  remaining: number;
  used: number;
  usedPercent: number;
  carriedOverVolume: number;
  carriedOverRemaining: number;
  carriedOverUsed: number;
  carriedOverUsedPercent: number;
}

export interface ISubscriptionDetails {
  planId: number;
  planTypeId: number;
  planName: string;
  description: string;
  tag: string;
  priceSAR: number;
  vatRate: number;
  vatAmountSAR: number;
  totalAmountSAR: number;
  priceUSD: number;
  expirationDate: string;
  renewalDate: string;
  statusId: number;
  isCanceled: boolean;
  nextPlanId?: number;
  rank: number;
  planDurationId: number;
}

export interface Subscription {
  id: number;
  accountId: number;
  planId: number;
  statusId: number;
  startDate: string;
  expirationDate: string;
  nextPlanId?: number;
  renewalDate?: string;
  isCanceled: boolean;
  isAutoRenewal: boolean;
  lastRescheduleDate?: string;
}

export enum SUBSCRIPTION_STATUS {
  ACTIVE = 1,
  EXPIRED = 2,
}

export enum PLAN_TYPE {
  STANDARD = 1,
  CUSTOM = 2,
  CONTACT_US = 3,
  TRIAL = 4,
  CONNECTOR = 5,
  DEFAULT = 6
}

export enum PAYMENT_PURPOSE {
  SUBSCRIPTION = 1,
  RENEWAL = 2,
  TOP_UP = 3,
  ADD_ON = 4,
}

export enum PAYMENT_SOURCE {
  CUSTOMER_INITIATED = 1,
  MERCHANT_INITIATED = 2,
  ADMIN_INITIATED = 3,
}

export enum PAYMENT_TYPE {
  ONLINE = 1,
  OFFLINE = 2,
}
